<template>
  <section
    v-if="visible && userTrail && userTrail.name"
    class="container"
    :class="$style.trailResume"
  >
    <router-link :to="{ name: 'trail.my' }" :class="$style.trailResume__inner">
      <CloseButton
        @click.stop.prevent="visible = false"
        aria-label="Fechar"
      >×</CloseButton>

      <div :class="$style.trailResume__label1">Continue sua jornada na trilha de</div>
      <div :class="$style.trailResume__label2">{{ userTrail.name }}</div>
  
      <div :class="$style.trailResume__progress">
        <BaseProgressBar :value="userTrail.trail_attended_percent"/>
      </div>
    </router-link>
  </section>
</template>

<script>
import { ref } from '@vue/composition-api'
import BaseProgressBar from '@/components/progressbar/BaseProgressBar'
import { useUserTrail } from './trail'
import CloseButton from '@/components/buttons/CloseButton'

export default {
  name: 'TrailResume',

  components: {
    BaseProgressBar,
    CloseButton,
  },

  setup () {
    const { userTrail } = useUserTrail()
    const visible = ref(true)

    return { userTrail, visible }
  }
}
</script>

<style lang="scss" scoped module>
@import "~@/components/trail/trail.scss";

.trailResume {
  text-align: center;
  position: fixed;
  left: 24px;
  bottom: 24px;
  z-index: 100;

  &__close {
    position: absolute;
    top: -3px;
    right: 5px;
    background: transparent;
    border: none;
    font-size: 1.5rem;
    color: #fff;
    cursor: pointer;
    z-index: 101;
    padding: 0;
    line-height: 1;
  }

  &__inner {
    position: relative;
    display: inline-block;
    // border-bottom: 2px solid var(--trailColor);
    // background: radial-gradient(56.27% 117.62% at 37.5% 100%, rgba(255, 255, 255, 0.29) 0%, rgba(255, 255, 255, 0.05) 100%), radial-gradient(108.23% 146.28% at 50% 0%, rgba(32, 32, 32, 0.00) 11.38%, rgba(91, 0, 105, 0.70) 68.27%), radial-gradient(178.09% 220.16% at 94.89% -132.81%, #9000F0 67.59%, rgba(253, 212, 155, 0.38) 100%), #000;
    background: $purple600;
    padding: 1rem;
    box-shadow: 0px 8px 12px 2px $purple900;
    text-align: center;
    border-radius: 8px;
  }

  &__progress {
    margin: 16px auto 0;
  }

  &__label1 {
    font-size: 0.9375rem;
  }

  &__label2 {
    color: $highlightPrimaryColor;
  }

  @media (max-width: 550px) {
    // position: relative;
    // inset: auto;
    // margin-top: 32px;
    // padding: 0 15px;
    
    &__inner {
      display: block;
      box-shadow: 0 0 0;
      border-radius: 0;
      border: 1px solid var(--trailColor);
      border-left: 3px solid var(--trailColor);
      border-radius: 8px;;
    }

     &__close {
      top: 4px;
      right: 8px;
    }
  }
}
</style>